import * as Sentry from "@sentry/vue"
import queryInitInfo from "@/services/queryInitInfo"
import { setTimezone } from "@/plugins/dayJsConfig"

export const useFetchInitInfo = () => {
  const walletStore = useWalletStore()
  const websiteInfoStore = useWebsiteInfoStore()

  const fetchInitInfo = async () => {
    try {
      const { handler } = queryInitInfo

      const res = await handler()
      const { updateInitInfo } = websiteInfoStore
      const { updateCurrency } = walletStore

      updateInitInfo(res)

      if (res.queryPass) {
        Sentry.setTag("queryPass", res.queryPass)
      }

      updateCurrency({
        id: res.playerCurrency,
        type: res.playerCurrencyType,
        symbol: res.currencySymbol,
        minBet: res.minBet
      })
      setTimezone(res.timeZone)

      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  return {
    fetchInitInfo
  }
}

export default useFetchInitInfo
